module.exports = __webpack_public_path__ + "img/C-01-min.c81a0f47.png";